import { useMutation } from "@tanstack/react-query";
import { apiClient } from "./api-client";

export function useGetAllNotifications({ basePath } = {}) {
  const notificationsPath = basePath || "admin/notifications/all";
  return useMutation({
    mutationFn: ({ page, limit, search }) => {
      const params = new URLSearchParams({
        page: String(page),
        limit: String(limit)
      });

      if (search) {
        params.append("search", search);
      }

      return apiClient({
        url: `${notificationsPath}?${params.toString()}`,
        method: "GET"
      });
    }
  });
}

export function useMarkNotificationAsSeen() {
  return useMutation({
    mutationFn: (notificationId) => {
      return apiClient({
        url: `notifications/${notificationId}/seen`,
        method: "GET"
      });
    }
  });
}
